module.exports = __webpack_public_path__ + "img/icon1.ec923722.png";